import { parseExperiencesHeader } from "@packages/feature-flags";

export const getProductListFlags = (experiencesRawString?: string) => {
  if (!experiencesRawString) {
    return {};
  }

  const parameterPrefix = "product-list-plp-";

  return parseExperiencesHeader(experiencesRawString).reduce(
    (acc: Record<string, string>, experience) => {
      Object.entries(experience.parameters || {}).forEach(
        ([parameterName, parameterValue]) => {
          if (parameterName.startsWith(parameterPrefix)) {
            const flagName = parameterName.replace(parameterPrefix, "");
            acc[flagName] = String(parameterValue);
          }
        },
      );
      return acc;
    },
    {},
  );
};
